import { RouteObject } from "react-router";
import AppExtensionProviderRegistry, { AppExtension, AppExtensionProvider } from "../../framework/app/app.extension.provider";
import { DashboardComponent } from "react-admin";
import NEOMenu from "./neo.custom.menu";
import NEOWelcomePage from "./welcome/neo.welcome.page";


export const PRODUCT = "neo";

export class NEOAppExtensionProvider implements AppExtensionProvider {
    
    constructor() { 
      console.log('NEOAppExtensionProvider: constructor');
      console.log('NEOAppExtensionProvider: PRODUCT', PRODUCT);
      AppExtensionProviderRegistry.registerProvider(
        PRODUCT,
        this
      );
    }
    
    getAppExtension(): AppExtension {
      return {
        getAppImage: () => {
            return `./products/${PRODUCT}/banner.png`
        },
        getAppBar: () => {
          return null;
        },
        getMenu: () => {
          return NEOMenu;
        },
        getRoutes: ():RouteObject[] => {
          const welcome:RouteObject = {
            path: "/welcomeToNEO",
            element: NEOWelcomePage
        }
        return [welcome];
        },
        getDefaultRoute: () => {
            return `/welcomeToNEO`;
        },
        getWelcomePage():DashboardComponent {
            return NEOWelcomePage;
        },
      };
    }
  }